import React from 'react';
import TopNavBar from './screens/TopNav/TopNav';
import Home from './screens/Home/Home';
import AboutUs from './screens/AboutUs/AboutUs';
import OurServices from './screens/OurService/OurServices';
import Products from './screens/Products/Products';
import ContactUs from './screens/ContactUs/ContactUs';
import Footer from './screens/footer/Footer';

function App() {
  return (
    <>
      <TopNavBar />
      <div style={{background: 'linear-gradient(180deg, #F8F9FA 0%, #FFFFFF 100%)'}}>÷\
        <section id="home"><Home /></section>
        <section id="aboutUs"><AboutUs /></section>
        <section id="ourServices"><OurServices /></section>
        <section id="products"><Products /></section>
        <section id="contactus"><ContactUs /></section>
      </div>
      <Footer />
    </>
  );
}

export default App;
